import { useGetCopilotQuery, useListCopilotsSummariesQuery } from '../../../../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotCustomCopilotsService.hooks';
import { useHasChatAgentAccess, useHasCopilotCollabInteractiveModeAccess, useHasSalesCopilotAccess } from '../../../../gating/hooks/useHasAccess';
import { useIsUngatedForBreezeRebrand } from '../../../../gating/hooks/useIsUngatedForBreezeRebrand';
import { useHostAppContext } from '../../../../hostAppContext/hooks/useAppContext';
import { INTERACTIVE_MODE_COPILOT_ASSISTANT, SALES_COPILOT_ASSISTANT, getBreezeCopilotAssistant } from '../constants/assistants';
import { transformCopilotSummaryToAssistant, transformCopilotToCopilotSummary } from '../utils/assistantsTypeTransforms';

// TODO - try to memoize this hook
export const useAssistants = () => {
  const isUngatedForBreezeRebrand = useIsUngatedForBreezeRebrand();
  const {
    customCopilotId: initialCustomCopilotId,
    isPreviewMode
  } = useHostAppContext();
  const hasCopilotCollabInteractiveModeAccess = useHasCopilotCollabInteractiveModeAccess();
  const hasSalesCopilotAccess = useHasSalesCopilotAccess();
  const hasChatAgentAccess = useHasChatAgentAccess();
  const {
    loading,
    error,
    data: {
      copilots: customCopilots
    } = {
      copilots: []
    }
  } = useListCopilotsSummariesQuery({
    skip: !hasChatAgentAccess
  });

  // List Copilot only displays active custom assistants, this will allow us to get the draft custom copilot
  const {
    loading: loadingDraftCustomCopilot,
    data: {
      copilot: draftCustomCopilot
    } = {}
  } = useGetCopilotQuery({
    variables: {
      customCopilotId: Number(initialCustomCopilotId)
    },
    skip: !initialCustomCopilotId || !isPreviewMode
  });
  if (!customCopilots || loading || error || loadingDraftCustomCopilot) {
    return {
      assistants: [],
      loading: loading || loadingDraftCustomCopilot
    };
  }

  // Adds BREEZE as a default assistant
  const assistants = [getBreezeCopilotAssistant(isUngatedForBreezeRebrand)];
  if (hasCopilotCollabInteractiveModeAccess) {
    assistants.push(INTERACTIVE_MODE_COPILOT_ASSISTANT);
  }
  if (hasSalesCopilotAccess) {
    assistants.push(SALES_COPILOT_ASSISTANT);
  }
  if (hasChatAgentAccess) {
    /** We only want to show published custom copilots
     * If we are in preview mode, we want to show the draft custom copilot
     * at the top of the list
     */
    const publishedCustomCopilots = customCopilots.filter(copilot => copilot.status === 'ACTIVE');
    // We only want to add the draft custom copilot if it isn't already in publishedCustomCopilots
    const isDraftCustomCopilotPublished = publishedCustomCopilots.some(copilot => copilot.id === initialCustomCopilotId);
    if (!isDraftCustomCopilotPublished && initialCustomCopilotId && isPreviewMode) {
      if (draftCustomCopilot) {
        publishedCustomCopilots.unshift(transformCopilotToCopilotSummary(draftCustomCopilot));
      }
    }
    const chatAgents = publishedCustomCopilots.map(transformCopilotSummaryToAssistant);
    // Type assertion to ensure the transformed agents match the Assistant type
    assistants.push(...chatAgents);
  }
  return {
    assistants,
    loading: loading || loadingDraftCustomCopilot
  };
};